// extracted by mini-css-extract-plugin
module.exports = {"root":"app-map-module_root_3G8x4"};